import React from 'react';
import { IconCheck } from '@tabler/icons-react';
import './MediaSelectionTiles.css';

// Horizontal picker for Mythic Maps media items. Each tile shows either an
// actual asset thumbnail (when `item.uri` is provided) or a fallback icon (for
// generic settings UIs where there is no specific media to preview).
//
// Usage:
//   tiles = [{ key, label, item?, icon? }, ...]
//   selection = { [key]: boolean }
//   onToggle = (key) => void
const MediaSelectionTiles = ({
  tiles,
  selection,
  onToggle,
  label,
}) => {
  return (
    <div className="media-selection">
      {label && <p className="media-selection-label">{label}</p>}
      <div className="media-selection-tiles">
        {tiles.map(({ key, item, icon, label: tileLabel, available }) => {
          // `available` lets the caller force-disable a tile (e.g. when an
          // asset is missing). When omitted we fall back to the presence of
          // either an item or an icon.
          const isAvailable = available !== undefined ? available : Boolean(item || icon);
          const selected = isAvailable && selection[key];
          return (
            <button
              key={key}
              type="button"
              className={`media-tile ${selected ? 'selected' : ''} ${isAvailable ? '' : 'disabled'}`}
              onClick={() => isAvailable && onToggle(key)}
              disabled={!isAvailable}
              aria-pressed={selected}
              aria-label={tileLabel}
            >
              <div className="media-tile-thumb">
                {isAvailable && item?.kind === 'video' ? (
                  <>
                    <video src={item.uri} muted autoPlay loop preload="auto" playsInline />
                    <span className="media-tile-play" aria-hidden="true">▶</span>
                  </>
                ) : isAvailable && item?.kind === 'transition-preview' ? (
                  <>
                    <div className="media-tile-transition-preview">
                      <img className="media-tile-transition-frame original" src={item.beforeUri} alt="" />
                      <img className="media-tile-transition-frame generated" src={item.afterUri} alt="" />
                    </div>
                    <span className="media-tile-play" aria-hidden="true">▶</span>
                  </>
                ) : isAvailable && item?.uri ? (
                  <img src={item.uri} alt="" />
                ) : isAvailable && icon ? (
                  <span className="media-tile-icon" aria-hidden="true">{icon}</span>
                ) : (
                  <span className="media-tile-empty" aria-hidden="true">—</span>
                )}
                {selected && (
                  <span className="media-tile-check" aria-hidden="true">
                    <IconCheck size={14} />
                  </span>
                )}
              </div>
              <span className="media-tile-label">{tileLabel}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MediaSelectionTiles;
